// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".has-table-full-modal .ant-modal-body {\n  padding: 0;\n}\n", "",{"version":3,"sources":["/Users/mht/Desktop/Work/GE/SPO-V-FE/src/views/master-data-maintenance/tx-bom.vue"],"names":[],"mappings":"AACE;EAEI,UAAA;AADN","file":"tx-bom.vue","sourcesContent":["\n  .has-table-full-modal {\n    .ant-modal-body {\n      padding: 0;\n    }\n  }\n\n@spo-color-blue: #46649f;@spo-margin: 20px;@spo-padding: 20px;@spo-header-height: 65px;@primary-color: #46649f;@link-color: #46649f;"]}]);
// Exports
module.exports = exports;
